import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { FINANCIMENTO_INDIRETO } from "src/constants";
import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store";
import cartasCreditoProvider from "src/providers/pagamentos/CartaCreditoProvider";
import { CartaCreditoType, PedidoType } from "src/types";
import { FinanciamentoIndireto } from "../../financiamentoIndireto/FinanciamentoIndireto";


import "./styles.scss";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";

interface FinanciamentoIndiretoDocumentosProperties {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    pedido: any;
}

const FinanciamentoIndiretoDocumentos: FC<FinanciamentoIndiretoDocumentosProperties> = ({
    open,
    onClose,
    onConfirm,
    pedido
}) => {
    const history = useHistory()

    const confirmarPagamento = async (pagamentoId: number, data: any): Promise<void> => {
        try {
            const response: IDataResponse = await cartasCreditoProvider.saveAtualizarCartaCredito(pagamentoId, data);

            if (response.statusCode === STATUS_CODE.OK) {
                notifierStore.setNotifier({
                    title: "Aviso",
                    content: "Documentos enviados com sucesso!",
                    timeOut: 3500,
                    onClose: () => {
                        notifierStore.setOpen(false);
                        history.push("/");
                        onClose();
                    }
                })
                notifierStore.setOpen(true)
            }
        } catch (error) {

        }
    }

    return <div>
        <Dialog open={open} className="FinanciamentoIndiretoDocumentos" fullWidth={true} maxWidth="md">
            <DialogTitle>Faça o envio dos documentos solicitados.</DialogTitle>
            <DialogContent>
                <FinanciamentoIndireto
                    checkout={false}
                    formaPagamentoId={FINANCIMENTO_INDIRETO.id}
                    codigoVenda={pedido?.codigo_venda || ""}
                    cupomDesconto={pedido?.codigo_cupom || ""}
                    pagamentoId={pedido?.pagamento_id || 0}
                    solo
                    exibirBotoes={true}
                    onConfirmar={async (value: CartaCreditoType) => {
                        if (pedido?.codigo_venda) {
                            const pedidosProvider = new PedidosProvider();
                            const responsePedido: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedido.codigo_venda);
                            if (responsePedido.statusCode !== STATUS_CODE.OK) return;
                        }
                        
                        const data = {
                            situacao_carta: pedido?.situacao_carta === "pendente" ? "preenchido" : pedido?.situacao_carta,
                            situacao_comprovante: pedido?.situacao_carta === "pendente" ? pedido?.situacao_comprovante : pedido?.situacao_comprovante === "pendente" ? "preenchido" : pedido?.situacao_comprovante,
                            uploads: value.carta
                        }

                        confirmarPagamento(pedido?.pagamento_id || 0, data);

                        if (onConfirm) {
                            onConfirm();
                        }
                    }}
                    onClose={() => {
                        onClose();
                    }} />
            </DialogContent>

        </Dialog>
    </div>
}

export { FinanciamentoIndiretoDocumentos }